var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "tab-vessel-eq", attrs: { id: "tabVesselEq" } },
        [
          _c("div", { staticStyle: { width: "fit-content" } }, [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonly || _vm.hasMaster,
                        "label-width": "85px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.BookingInfo")))
                          ]),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_VehicleModel")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  "method-params": { typeKh: true },
                                  no: "vehicleType",
                                  "show-custom-label-in-option": true,
                                  "custom-label": _vm.vehicleTypeLabel,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_VehicleModel,
                                  filterable: "",
                                  clearable: false,
                                  "default-value": _vm.form.vehicleType
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.vehicleType = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SeaExport.PlateNumber") }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "plateNumber", maxlength: 10 },
                                model: {
                                  value: _vm.form.plateNumber,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "plateNumber", $$v)
                                  },
                                  expression: "form.plateNumber"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_trailerNumber")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "trailerNumber", maxlength: 10 },
                                model: {
                                  value: _vm.form.trailerNumber,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "trailerNumber", $$v)
                                  },
                                  expression: "form.trailerNumber"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "CMR" + _vm.$t("SeaExport.NO") }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "mbl" },
                                model: {
                                  value: _vm.form.mbl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "mbl", $$v)
                                  },
                                  expression: "form.mbl"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                            [
                              _c("el-input", {
                                attrs: {
                                  no: "remarks",
                                  maxlength: 300,
                                  type: "textarea",
                                  rows: 5
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.Remarks"),
                                      _vm.form.remarks,
                                      function(val) {
                                        _vm.form.remarks = val
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.remarks,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "remarks", $$v)
                                  },
                                  expression: "form.remarks"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "section form-column",
                  staticStyle: { width: "430px" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": "120px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_polExchangeInfo")))
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_trailerLoad") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%" },
                            attrs: {
                              no: "estTakeTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_estTime")
                            },
                            on: {
                              change: function($event) {
                                return _vm.changeTakeTime(false)
                              }
                            },
                            model: {
                              value: _vm.form.estTakeTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estTakeTime", $$v)
                              },
                              expression: "form.estTakeTime"
                            }
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%", left: "2px" },
                            attrs: {
                              no: "actTakeTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_actTime")
                            },
                            on: {
                              change: function($event) {
                                return _vm.changeTakeTime(true)
                              }
                            },
                            model: {
                              value: _vm.form.actTakeTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actTakeTime", $$v)
                              },
                              expression: "form.actTakeTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_trailerArrive")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%" },
                            attrs: {
                              no: "estArriveTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_estTime")
                            },
                            on: {
                              change: function($event) {
                                return _vm.changeArriveTime(false)
                              }
                            },
                            model: {
                              value: _vm.form.estArriveTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estArriveTime", $$v)
                              },
                              expression: "form.estArriveTime"
                            }
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%", left: "2px" },
                            attrs: {
                              no: "actArriveTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_actTime")
                            },
                            on: {
                              change: function($event) {
                                return _vm.changeArriveTime(true)
                              }
                            },
                            model: {
                              value: _vm.form.actArriveTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actArriveTime", $$v)
                              },
                              expression: "form.actArriveTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_trailerUnload")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%" },
                            attrs: {
                              no: "estUnloadTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_estTime")
                            },
                            model: {
                              value: _vm.form.estUnloadTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estUnloadTime", $$v)
                              },
                              expression: "form.estUnloadTime"
                            }
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%", left: "2px" },
                            attrs: {
                              no: "actUnloadTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_actTime")
                            },
                            model: {
                              value: _vm.form.actUnloadTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actUnloadTime", $$v)
                              },
                              expression: "form.actUnloadTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "title",
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "10px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_polPortInfo")))]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_khLandingTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%" },
                            attrs: {
                              no: "estLandingTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_estTime")
                            },
                            model: {
                              value: _vm.form.estLandingTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estLandingTime", $$v)
                              },
                              expression: "form.estLandingTime"
                            }
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%", left: "2px" },
                            attrs: {
                              no: "actLandingTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_actTime")
                            },
                            model: {
                              value: _vm.form.actLandingTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actLandingTime", $$v)
                              },
                              expression: "form.actLandingTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_khEntryTime") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%" },
                            attrs: {
                              no: "estEntryTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_estTime")
                            },
                            model: {
                              value: _vm.form.estEntryTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estEntryTime", $$v)
                              },
                              expression: "form.estEntryTime"
                            }
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%", left: "2px" },
                            attrs: {
                              no: "actEntryTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_actTime")
                            },
                            model: {
                              value: _vm.form.actEntryTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actEntryTime", $$v)
                              },
                              expression: "form.actEntryTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_khReplacementTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%" },
                            attrs: {
                              no: "estReplacementTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_estTime")
                            },
                            on: {
                              change: function($event) {
                                return _vm.changeReplacementTime(false)
                              }
                            },
                            model: {
                              value: _vm.form.estReplacementTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estReplacementTime", $$v)
                              },
                              expression: "form.estReplacementTime"
                            }
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%", left: "2px" },
                            attrs: {
                              no: "actReplacementTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_actTime")
                            },
                            on: {
                              change: function($event) {
                                return _vm.changeReplacementTime(true)
                              }
                            },
                            model: {
                              value: _vm.form.actReplacementTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actReplacementTime", $$v)
                              },
                              expression: "form.actReplacementTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_khDeclare") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%" },
                            attrs: {
                              no: "estDeclareTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_estTime")
                            },
                            model: {
                              value: _vm.form.estDeclareTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estDeclareTime", $$v)
                              },
                              expression: "form.estDeclareTime"
                            }
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%", left: "2px" },
                            attrs: {
                              no: "declareTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_actTime")
                            },
                            model: {
                              value: _vm.form.declareTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "declareTime", $$v)
                              },
                              expression: "form.declareTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_khExitTime") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%" },
                            attrs: {
                              no: "estExitTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_estTime")
                            },
                            model: {
                              value: _vm.form.estExitTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estExitTime", $$v)
                              },
                              expression: "form.estExitTime"
                            }
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%", left: "2px" },
                            attrs: {
                              no: "actExitTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_actTime")
                            },
                            model: {
                              value: _vm.form.actExitTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actExitTime", $$v)
                              },
                              expression: "form.actExitTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "title",
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "10px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_transferTransitInfo"))
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_transferDeclareCompleted"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%" },
                            attrs: {
                              no: "estDeclareCompletedTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_estTime")
                            },
                            model: {
                              value: _vm.form.estDeclareCompletedTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "estDeclareCompletedTime",
                                  $$v
                                )
                              },
                              expression: "form.estDeclareCompletedTime"
                            }
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%", left: "2px" },
                            attrs: {
                              no: "declareCompletedTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_actTime")
                            },
                            model: {
                              value: _vm.form.declareCompletedTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "declareCompletedTime", $$v)
                              },
                              expression: "form.declareCompletedTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_transferShipping")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%" },
                            attrs: {
                              no: "estShippingTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_estTime")
                            },
                            model: {
                              value: _vm.form.estShippingTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estShippingTime", $$v)
                              },
                              expression: "form.estShippingTime"
                            }
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%", left: "2px" },
                            attrs: {
                              no: "actShippingTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_actTime")
                            },
                            model: {
                              value: _vm.form.actShippingTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actShippingTime", $$v)
                              },
                              expression: "form.actShippingTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_arriveDestinationBorder"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%" },
                            attrs: {
                              no: "estArrivePodTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_estTime")
                            },
                            model: {
                              value: _vm.form.estArrivePodTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estArrivePodTime", $$v)
                              },
                              expression: "form.estArrivePodTime"
                            }
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%", left: "2px" },
                            attrs: {
                              no: "actArrivePodTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_actTime")
                            },
                            model: {
                              value: _vm.form.actArrivePodTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actArrivePodTime", $$v)
                              },
                              expression: "form.actArrivePodTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "title",
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "10px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_podClearInfo")))]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_arrivePod") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%" },
                            attrs: {
                              no: "estEnterPodTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_estTime")
                            },
                            model: {
                              value: _vm.form.estEnterPodTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estEnterPodTime", $$v)
                              },
                              expression: "form.estEnterPodTime"
                            }
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%", left: "2px" },
                            attrs: {
                              no: "actEnterPodTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_actTime")
                            },
                            model: {
                              value: _vm.form.actEnterPodTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actEnterPodTime", $$v)
                              },
                              expression: "form.actEnterPodTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_arriveClear") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%" },
                            attrs: {
                              no: "estArriveClearTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_estTime")
                            },
                            model: {
                              value: _vm.form.estArriveClearTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estArriveClearTime", $$v)
                              },
                              expression: "form.estArriveClearTime"
                            }
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%", left: "2px" },
                            attrs: {
                              no: "actArriveClearTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_actTime")
                            },
                            model: {
                              value: _vm.form.actArriveClearTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actArriveClearTime", $$v)
                              },
                              expression: "form.actArriveClearTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_khUnloading") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%" },
                            attrs: {
                              no: "estDischargeTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_estTime")
                            },
                            on: {
                              change: function($event) {
                                return _vm.changeDischargeTime(false)
                              }
                            },
                            model: {
                              value: _vm.form.estDischargeTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estDischargeTime", $$v)
                              },
                              expression: "form.estDischargeTime"
                            }
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%", left: "2px" },
                            attrs: {
                              no: "actDischargeTime",
                              type: "datetime",
                              disabled: _vm.hasMaster,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_actTime")
                            },
                            on: {
                              change: function($event) {
                                return _vm.changeDischargeTime(true)
                              }
                            },
                            model: {
                              value: _vm.form.actDischargeTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actDischargeTime", $$v)
                              },
                              expression: "form.actDischargeTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "title",
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "10px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_podDeliveryInfo"))
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_warehouseDelivery")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%" },
                            attrs: {
                              no: "estWarehouseDeliveryTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_estTime")
                            },
                            model: {
                              value: _vm.form.estWarehouseDeliveryTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "estWarehouseDeliveryTime",
                                  $$v
                                )
                              },
                              expression: "form.estWarehouseDeliveryTime"
                            }
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%", left: "2px" },
                            attrs: {
                              no: "actWarehouseDeliveryTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_actTime")
                            },
                            model: {
                              value: _vm.form.actWarehouseDeliveryTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "actWarehouseDeliveryTime",
                                  $$v
                                )
                              },
                              expression: "form.actWarehouseDeliveryTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_goodsDelivery")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%" },
                            attrs: {
                              no: "estGoodsDeliveryTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_estTime")
                            },
                            model: {
                              value: _vm.form.estGoodsDeliveryTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estGoodsDeliveryTime", $$v)
                              },
                              expression: "form.estGoodsDeliveryTime"
                            }
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%", left: "2px" },
                            attrs: {
                              no: "actGoodsDeliveryTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_actTime")
                            },
                            model: {
                              value: _vm.form.actGoodsDeliveryTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actGoodsDeliveryTime", $$v)
                              },
                              expression: "form.actGoodsDeliveryTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_podReturn") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%" },
                            attrs: {
                              no: "estReturnTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_estTime")
                            },
                            model: {
                              value: _vm.form.estReturnTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estReturnTime", $$v)
                              },
                              expression: "form.estReturnTime"
                            }
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "49.5%", left: "2px" },
                            attrs: {
                              no: "actReturnTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder: _vm.$t("CargoMsg.Cargo_actTime")
                            },
                            model: {
                              value: _vm.form.actReturnTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actReturnTime", $$v)
                              },
                              expression: "form.actReturnTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "form-card",
                      staticStyle: { height: "100%" },
                      attrs: {
                        disabled: _vm.readonly || _vm.hasMaster,
                        "label-width": "130px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.SecondVesselInformation"))
                        )
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_secondPlateNumber")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "secondPlateNumber" },
                            model: {
                              value: _vm.form.secondPlateNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondPlateNumber", $$v)
                              },
                              expression: "form.secondPlateNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_secondTrailerNumber")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "secondTrailerNumber" },
                            model: {
                              value: _vm.form.secondTrailerNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondTrailerNumber", $$v)
                              },
                              expression: "form.secondTrailerNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_secondVehicleType")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              "method-params": { typeKh: true },
                              no: "secondVehicleType",
                              "select-type":
                                _vm.selectTypeNames.basic_data_VehicleModel,
                              filterable: "",
                              clearable: false,
                              "show-custom-label-in-option": true,
                              "custom-label": _vm.vehicleTypeLabel,
                              "default-value": _vm.form.secondVehicleType
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.secondVehicleType = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_secondEtd") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "secondEtd",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.secondEtd,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondEtd", $$v)
                              },
                              expression: "form.secondEtd"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_secondPol") }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "secondPol" },
                            model: {
                              value: _vm.form.secondPol,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondPol", $$v)
                              },
                              expression: "form.secondPol"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_secondPod") }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "secondPod" },
                            model: {
                              value: _vm.form.secondPod,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondPod", $$v)
                              },
                              expression: "form.secondPod"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_secondLoadingTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "secondLoadingTime",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.secondLoadingTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondLoadingTime", $$v)
                              },
                              expression: "form.secondLoadingTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_secondShippingTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "secondShippingTime",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.secondShippingTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondShippingTime", $$v)
                              },
                              expression: "form.secondShippingTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_secondArriveTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "secondArriveTime",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.secondArriveTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondArriveTime", $$v)
                              },
                              expression: "form.secondArriveTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_secondDischargeTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "secondDischargeTime",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.secondDischargeTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondDischargeTime", $$v)
                              },
                              expression: "form.secondDischargeTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_secondTransportType")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "secondTransportType" },
                            model: {
                              value: _vm.form.secondTransportType,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondTransportType", $$v)
                              },
                              expression: "form.secondTransportType"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "title",
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-bottom": "10px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_bargeInfo")))]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_bargeEtd") } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "bargeEtd",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.bargeEtd,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bargeEtd", $$v)
                              },
                              expression: "form.bargeEtd"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_bargeAtd") } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "bargeAtd",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.bargeAtd,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bargeAtd", $$v)
                              },
                              expression: "form.bargeAtd"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_bargePlateNumber")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "bargePlateNumber" },
                            model: {
                              value: _vm.form.bargePlateNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bargePlateNumber", $$v)
                              },
                              expression: "form.bargePlateNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_bargeTrailerNumber")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "bargeTrailerNumber" },
                            model: {
                              value: _vm.form.bargeTrailerNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bargeTrailerNumber", $$v)
                              },
                              expression: "form.bargeTrailerNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_bargePol") } },
                        [
                          _c("el-input", {
                            attrs: { no: "bargePol" },
                            model: {
                              value: _vm.form.bargePol,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bargePol", $$v)
                              },
                              expression: "form.bargePol"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_bargePod") } },
                        [
                          _c("el-input", {
                            attrs: { no: "bargePod" },
                            model: {
                              value: _vm.form.bargePod,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bargePod", $$v)
                              },
                              expression: "form.bargePod"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_bargeLine") }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "bargeLine" },
                            model: {
                              value: _vm.form.bargeLine,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bargeLine", $$v)
                              },
                              expression: "form.bargeLine"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_CYCutOffDate")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "bargeClosingDate",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.bargeClosingDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bargeClosingDate", $$v)
                              },
                              expression: "form.bargeClosingDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_bargeCarrierId")
                          }
                        },
                        [
                          _c("cargo-company-select", {
                            attrs: {
                              no: "bargeCarrierId",
                              "method-params": {
                                truckCmp: true,
                                active: true,
                                companyLob: "integratedJob"
                              },
                              "default-value": _vm.form.bargeCarrierId || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.form.bargeCarrierId = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "bargeRemarks",
                              type: "textarea",
                              rows: 5
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Remarks"),
                                  _vm.form.bargeRemarks,
                                  function(val) {
                                    _vm.form.bargeRemarks = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.bargeRemarks,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bargeRemarks", $$v)
                              },
                              expression: "form.bargeRemarks"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.advanceTextDialog.visible,
                title: _vm.advanceTextDialog.title,
                width: "600px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.advanceTextDialog, "visible", $event)
                }
              }
            },
            [
              _c("el-input", {
                attrs: { disabled: _vm.readonly, type: "textarea", rows: "10" },
                model: {
                  value: _vm.advanceTextDialog.value,
                  callback: function($$v) {
                    _vm.$set(_vm.advanceTextDialog, "value", $$v)
                  },
                  expression: "advanceTextDialog.value"
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.finishAdvanceText }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.advanceTextDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }